(() => {
  const drawer = document.getElementById('OsvayneCartDrawer');
  if (!drawer || !drawer.showModal || !window.fetch) return;
  const route = window.Shopify?.routes?.root || '/';
  const status = document.getElementById('CartDrawerStatus');
  let busy = false;
  let cartPageChanged = false;
  let returnFocus;
  const announce = (message, error = false) => {
    status.textContent = message;
    status.dataset.error = String(error);
  };
  const setBusy = value => {
    busy = value;
    document.getElementById('CartDrawerContent').setAttribute('aria-busy', String(value));
  };
  const open = () => {
    if (!drawer.open) {
      returnFocus = document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('ov-cart-open');
    }
  };
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('ov-cart-open');
    if (cartPageChanged && location.pathname === route + 'cart') {
      window.location.reload();
      return;
    }
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right) drawer.close();
  });
  const syncDrift = card => {
    const select = card.querySelector('[data-drift-variant]');
    const option = select.selectedOptions[0];
    const button = card.querySelector('[data-drift-add]');
    button.hidden = false;
    button.disabled = !select.value || option.disabled;
    if (!select.value) return;
    card.querySelector('[data-drift-price]').textContent = option.dataset.offerPrice;
    card.querySelector('[data-drift-original]').textContent = option.dataset.originalPrice;
    const image = card.querySelector('template[data-drift-media="' + option.dataset.media + '"]');
    if (image) card.querySelector('[data-drift-photo]').replaceChildren(image.content.cloneNode(true));
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-drift-variant]')) syncDrift(event.target.closest('[data-drift-offer]'));
  });
  const setupOffers = () => {
    document.querySelectorAll('[data-drift-offer]').forEach(syncDrift);
    drawer.querySelectorAll('[data-upsell-product]').forEach(card => {
      const variants = JSON.parse(card.querySelector('[data-upsell-variants]').textContent);
      const form = card.querySelector('form');
      const selectors = [...form.querySelectorAll('[data-upsell-option]')];
      const fallback = form.querySelector('select[name=id]');
      const button = form.querySelector('[type=submit]');
      const sync = () => {
        const values = selectors.map(select => select.value);
        const exact = variants.find(variant => variant.options.every((option, index) => option === values[index]));
        const display = exact || variants.find(variant => variant.options[0] === values[0] && variant.available);
        fallback.value = exact?.id || '';
        button.disabled = !exact?.available || !exact?.priced;
        if (display) {
          card.querySelector('[data-upsell-price]').textContent = display.price;
          const template = card.querySelector(`template[data-upsell-media="${display.media}"]`);
          if (template) card.querySelector('[data-upsell-photo]').replaceChildren(template.content.cloneNode(true));
        }
      };
      form.querySelector('[data-upsell-enhanced]').hidden = false;
      form.querySelector('[data-upsell-fallback]').hidden = true;
      selectors.forEach(select => select.addEventListener('change', sync));
      sync();
    });
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.getElementById('CartDrawerContent');
    if (!content) throw new Error(drawer.dataset.error);
    document.getElementById('CartDrawerContent').replaceWith(content);
    cartPageChanged = true;
    drawer.querySelector('[data-cart-header-count]').textContent = `(${content.dataset.cartCount})`;
    document.querySelectorAll('.bag-link').forEach(link => {
      link.querySelector('span').textContent = `(${content.dataset.cartCount})`;
      link.setAttribute('aria-label', content.dataset.bagLabel);
    });
    setupOffers();
  };
  const refresh = async () => {
    const url = new URL(route, location.origin);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    const response = await fetch(url, {cache:'no-store'});
    if (!response.ok) throw new Error(drawer.dataset.error);
    render(await response.text());
  };
  const renderResponse = async data => {
    const section = data.sections?.[drawer.dataset.sectionId];
    if (section) render(section); else await refresh();
  };
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-cart-close]');
    if (close) { drawer.close(); return; }
    const bag = event.target.closest('.bag-link');
    if (bag && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      if (busy) { open(); return; }
      open(); setBusy(true); announce(drawer.dataset.adding);
      try { await refresh(); announce(''); }
      catch { announce(drawer.dataset.error, true); }
      finally { setBusy(false); }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (!change || busy) return;
    const key = change.closest('[data-line-key]').dataset.lineKey;
    const quantity = Number(change.dataset.cartChange);
    setBusy(true); announce(drawer.dataset.adding);
    try {
      const response = await fetch(route + 'cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:key,quantity,sections:[drawer.dataset.sectionId],sections_url:route})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.error);
      await renderResponse(data); announce('');
      const nextLine = [...drawer.querySelectorAll('[data-line-key]')].find(line => line.dataset.lineKey === key);
      (nextLine?.querySelector('[data-cart-change]') || drawer.querySelector('[data-cart-close]')).focus({preventScroll:true});
    } catch (error) { announce(error.message || drawer.dataset.error, true); }
    finally { setBusy(false); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.getAttribute('id') !== 'OsvayneProductForm' && !form.matches('[data-cart-upsell], [data-mary-drift-bundle]')) return;
    event.preventDefault();
    if (busy || form.dataset.cartAdding === 'true') return;
    const button = form.querySelector('[type=submit]');
    const label = button.textContent;
    const productStatus = form.querySelector('[role=status]');
    let added = false;
    setBusy(true); form.dataset.cartAdding = 'true'; button.disabled = true;
    button.textContent = drawer.dataset.adding;
    if (productStatus) productStatus.textContent = drawer.dataset.adding;
    try {
      let payload;
      const headers = {Accept:'application/json'};
      if (form.matches('[data-mary-drift-bundle]')) {
        const maryForm = document.getElementById('OsvayneProductForm');
        if (!maryForm || !maryForm.reportValidity()) throw new Error('Please choose your Mary Jane size and style.');
        const maryData = new FormData(maryForm);
        const maryOption = maryForm.querySelector('#VariantSelector')?.selectedOptions[0];
        if (maryOption?.dataset.available !== 'true') throw new Error('Please choose an available Mary Jane size and style.');
        const properties = {};
        for (const [key,value] of maryData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        payload = JSON.stringify({items:[
          {id:maryData.get('id'),quantity:Number(maryData.get('quantity') || 1),properties},
          {id:new FormData(form).get('id'),quantity:1}
        ],sections:drawer.dataset.sectionId,sections_url:route});
        headers['Content-Type'] = 'application/json';
      } else {
        payload = new FormData(form);
        payload.set('sections', drawer.dataset.sectionId);
        payload.set('sections_url', route);
      }
      const response = await fetch(route + 'cart/add.js', {method:'POST',body:payload,headers});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.error);
      added = true;
      await renderResponse(data); open(); announce(drawer.dataset.added);
      if (productStatus) productStatus.textContent = '';
    } catch (error) {
      if (added) {
        console.warn('OSVAYNE cart drawer refresh:', error.message);
        window.location.assign(route + 'cart');
      } else {
        const message = error.message || drawer.dataset.error;
        if (productStatus) productStatus.textContent = message;
        if (drawer.open) announce(message, true);
      }
    } finally {
      form.dataset.cartAdding = 'false';
      button.textContent = label;
      const selected = form.querySelector('#VariantSelector')?.selectedOptions[0];
      button.disabled = selected ? selected.dataset.available !== 'true' || selected.dataset.priced !== 'true' : false;
      if (form.closest('[data-drift-offer]')) syncDrift(form.closest('[data-drift-offer]'));
      setBusy(false);
    }
  });
  setupOffers();
})();

